(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var KEY = 'cdnp_scratch_session_seen';
    var delay = 5000;
    var threshold = (parseFloat(root.dataset.threshold) || 40) / 100;
    var code = root.dataset.code;
    var designMode = root.dataset.designMode === 'true';
    var forced = location.search.indexOf('scratch=1') > -1;
    var isHome = root.dataset.home === 'true';
    var shown = false;
    var card = root.querySelector('[data-card]');
    var canvas = root.querySelector('[data-canvas]');
    var form = root.querySelector('[data-form]');
    var done = root.querySelector('[data-done]');
    var revealBtn = root.querySelector('[data-reveal]');
    var msg = root.querySelector('[data-msg]');
    var submit = root.querySelector('[data-submit]');
    var ctx, revealed = false, drawing = false, last = null, moves = 0;

    function seenRecently() {
      try {
        return sessionStorage.getItem(KEY) === '1';
      } catch (e) { return false; }
    }
    function markSeen() { shown = true; try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
    function open() {
      if (!designMode && (!isHome || shown || seenRecently())) return;
      markSeen();
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(setupCanvas);
    }
    function close() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      markSeen();
    }
    root.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-scratch-open]');
      if (t) { e.preventDefault(); open(); }
    });

    function setupCanvas() {
      if (ctx) return;
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) { setTimeout(setupCanvas, 50); return; }
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.scale(dpr, dpr);
      var g = ctx.createLinearGradient(0, 0, r.width, r.height);
      g.addColorStop(0, root.dataset.foil1 || '#c8a27a');
      g.addColorStop(0.5, root.dataset.foil2 || '#ead9bd');
      g.addColorStop(1, root.dataset.foil1 || '#c8a27a');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, r.width, r.height);
      ctx.fillStyle = 'rgba(255,255,255,.18)';
      for (var i = 0; i < 40; i++) {
        ctx.fillRect(Math.random() * r.width, Math.random() * r.height, Math.random() * 60, 2);
      }
      ctx.fillStyle = 'rgba(255,255,255,.75)';
      ctx.font = '800 28px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(root.dataset.scratchLabel || 'RUBBEL HIER', r.width / 2, r.height / 2);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 38;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    }
    function pos(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function stroke(a, b) {
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
    }
    canvas.addEventListener('pointerdown', function (e) {
      if (revealed || !ctx) return;
      drawing = true;
      last = pos(e);
      canvas.setPointerCapture(e.pointerId);
      stroke(last, last);
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!drawing || revealed) return;
      var p = pos(e);
      stroke(last, p);
      last = p;
      if (++moves % 6 === 0) check();
    });
    function end() { drawing = false; if (!revealed && ctx) check(); }
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);

    function check() {
      var w = canvas.width, h = canvas.height, step = 8, cleared = 0, total = 0;
      var data = ctx.getImageData(0, 0, w, h).data;
      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          total++;
          if (data[(y * w + x) * 4 + 3] < 40) cleared++;
        }
      }
      if (total && cleared / total >= threshold) reveal();
    }
    function reveal() {
      if (revealed) return;
      revealed = true;
      canvas.classList.add('is-gone');
      revealBtn.hidden = true;
      form.hidden = false;
      setTimeout(function () { var i = form.querySelector('input[type=email]'); if (i) i.focus(); }, 300);
    }
    revealBtn.addEventListener('click', reveal);

    function subscribeKlaviyo(email) {
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Scratch Popup', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: root.dataset.klaviyoList } } } } };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.klaviyoCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
    }
    function subscribeShopify(email) {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'scratch-popup, newsletter');
      return fetch('/contact', { method: 'POST', body: fd }).then(function (r) { if (!r.ok) throw new Error('shopify ' + r.status); });
    }
    function validEmail(v) {
      var at = v.indexOf('@');
      return at > 0 && v.lastIndexOf('.') > at + 1 && v.indexOf(' ') < 0 && v.charAt(v.length - 1) !== '.';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.textContent = '';
      var email = form.elements.email.value.trim();
      if (!validEmail(email)) { msg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; return; }
      if (!form.elements.consent.checked) { msg.textContent = 'Bitte stimme der Einwilligung zu.'; return; }
      submit.disabled = true;
      var useKlaviyo = root.dataset.klaviyoCompany && root.dataset.klaviyoList;
      (useKlaviyo ? subscribeKlaviyo(email) : subscribeShopify(email)).then(function () {
        form.hidden = true;
        done.hidden = false;
        markSeen();
        try { localStorage.setItem('cdnp_scratch_done', '1'); } catch (err) {}
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }).catch(function () {
        submit.disabled = false;
        msg.textContent = 'Das hat leider nicht geklappt. Bitte versuche es später noch einmal.';
      });
    });

    var copyBtn = root.querySelector('[data-copy]');
    var hint = root.querySelector('[data-copy-hint]');
    copyBtn.addEventListener('click', function () {
      var finish = function () { hint.textContent = 'Kopiert'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(finish, finish); else finish();
    });

    var doneBefore = false;
    try { doneBefore = localStorage.getItem('cdnp_scratch_done') === '1'; } catch (e) {}
    if (designMode && forced) { open(); }
    else if (isHome && !seenRecently() && !doneBefore) {
      var delayPassed = false;
      var scrolled = false;
      function maybeOpen() {
        if (!delayPassed || !scrolled || document.visibilityState === 'hidden') return;
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('visibilitychange', maybeOpen);
        open();
      }
      function onScroll() {
        if (window.scrollY >= 150) scrolled = true;
        maybeOpen();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('visibilitychange', maybeOpen);
      setTimeout(function () { delayPassed = true; maybeOpen(); }, delay);
    }
  }

  function initAll() { document.querySelectorAll('.cdnp-scratch').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();